import React, { PureComponent } from 'react';
import { Link } from "react-router-dom";
import { Icon, List, Badge, Button, notification } from 'antd'
import styles from './index.less'
import HeaderDropdown from '../HeaderDropdown'
import Request from "../../request";
import moment from 'moment'

export default class Notifications extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            count: 0,
            data: [],
            lastTotalCount: 0
        };
        this.showNotification = this.showNotification.bind(this);
    }
    async showNotification(notificationTitle) {
       await new Notification(notificationTitle.tag, notificationTitle)
    }
    componentDidMount() {
        if (!("Notification" in window)) {
            console.log("Browser does not support desktop notification");
          } else {
            Notification.requestPermission();
          }
        // this.getAllNotifications();
        setInterval(() => {
            this.getAllNotifications();
        }, 120000);        
    }

    async getAllNotifications() {
        const params = {};
        params.sortField = 'lastMessageTime'
        params.sortOrder = 'descend'
        const res = await Request.fetchUnreadNotifications({
            ...params
        });
        if (res.success) {
            if(res.total > this.state.lastTotalCount) {
                let notification = res.data[0];
                let options = {
                    tag: 'Added by '+notification.from.name + ' AT '+(moment(notification.lastMessageTime).format('MMM DD, h:mm a')),
                    body: notification.description,
                    lang: 'en',
                    dir: 'ltr'
                }
                await this.showNotification(options);
            }
            this.setState({ count: res.total, data: res.data, lastTotalCount: res.total })
        }
    }

    async markAsUnReadNotificationsAPI() {
        await Request.markAsReadAllNotify({});
        await this.getAllNotifications();
    }

    markNotificationAsRead = async(_id) => {
        let _ids = [_id];
        await Request.markAsReadNotify({ _ids });
        await this.getAllNotifications();
    }

    handleMarkAsUnreadNotifications = () => {
        this.setState({ count: 0, data: [] });
        this.markAsUnReadNotificationsAPI();
    }

    render() {
        const { count, data } = this.state;
        const menu = (
            <div className={styles.notifyList}>
                <div className={styles.notifyWrapperTitle} >
                <Link to='/allnotifications'><span>Notifications</span></Link>
                    {data.length > 0 && (<span onClick={this.handleMarkAsUnreadNotifications}>Mark all as read</span>)}
                </div>
                <List
                    dataSource={data}
                    renderItem={item => (
                        <>
                            <List.Item key={item._id} >
                                <List.Item.Meta
                                    avatar={<Badge status="processing" />}
                                    title={<div className={styles.notifyMainTitle}>By {item.from.name}</div>}
                                    description={
                                        <div>
                                            <p className={styles.notifyText+' antd-header-notification '}>{item.description}</p>
                                            <span><b>Assigned At - </b>{moment(item.lastMessageTime).format('MMM DD, h:mm a')}</span>
                                            <br />
                                            <span className={styles.notifySubText}>
                                            <a onClick={() => {this.markNotificationAsRead(item._id)}}>Mark as read</a>
                                            {item && item.url?<Link to={`${item.url}`}>View Detail</Link>:null}
                                            </span>
                                        </div>
                                    }
                                />
                            </List.Item>
                        </>
                    )}
                />
                <Link to='/allnotifications'><span>View All Notifications</span></Link>
            </div>
        );

        return (
            <HeaderDropdown overlay={menu} trigger={['click']} className="ant-dropdown-open">
                <Badge count={count} >
                    <Icon type="notification" />
                </Badge>
            </HeaderDropdown>
        )
    }
}